import React from 'react';

const PropertyConveyIcon = () => {
  return (
    <>
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29 12.1749V29.0021H20.5417V20.6078L28.8973 16.3859L21.6219 11.1333C20.8655 10.7563 19.987 10.7962 19.2705 11.2384C18.5527 11.6819 18.125 12.4504 18.125 13.295V29.0021H0V12.1749C0 11.0173 0.523208 9.94307 1.43429 9.22774L12.1945 0.798406C13.5515 -0.266135 15.4485 -0.266135 16.8055 0.798406L27.5657 9.22895C28.4768 9.94428 29 11.0161 29 12.1749ZM20.5465 13.3373V17.8987L24.2621 16.021L20.5465 13.3373Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default PropertyConveyIcon;
